import * as React from 'react'
import { Header, Wrapper, WrapperCard } from './style'

interface RightSidebarFloatProps {
  header?: React.ReactNode
  body?: React.ReactNode
  footer?: React.ReactNode
  hideHeaderOnLg?: boolean
}

const RightSidebarFloat: React.FunctionComponent<RightSidebarFloatProps> = ({
  header,
  body,
  footer,
  hideHeaderOnLg,
}) => (
  <Wrapper>
    <WrapperCard>
      <Header hideHeaderOnLg={hideHeaderOnLg}>{header}</Header>
      {body}
      {footer}
    </WrapperCard>
  </Wrapper>
)

export default RightSidebarFloat
